/* Modositva: Akos | branch: dev/akos | 2026-11-03 - Kozos gyurukeszlet-tiltas visszavonasa, eredeti variansonkenti mukodes visszaallitasa. */
/* Modositva: Akos | branch: dev/akos | 2026-11-03 - Soros kosarba rakas, ket gomb tiltasa es a drawer helyreallitasanak megvarasa. */
(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.variantDisabled = this.submitButton.disabled;
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (this.isSubmitting) return;
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.handleErrorMessage();
      this.setSubmitting(true);
      const formData = new FormData(this.form);

      return window.themeCart.enqueue(async () => {
        this.cartDrawer = document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        formData.append(
          'sections',
          this.cartDrawer?.getSectionsToRender().map(section => section.section).join(',') || ''
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        const result = await fetch(`${routes.cart_add_url}`, config);
        const response = await result.json();
        if (!result.ok || response.status) {
          this.handleErrorMessage(response.description || window.cartStrings.error);
          return;
        }
        if (this.cartDrawer) {
          await this.cartDrawer.renderContents(response);
        } else {
          window.location.assign(`${window.Shopify.routes.root}cart`);
        }
      })
        .catch(error => {
          console.error(error);
          this.handleErrorMessage(window.cartStrings.error);
        })
        .finally(() => {
          this.setSubmitting(false);
        });
    }

    setSubmitting(busy) {
      this.isSubmitting = busy;
      [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach(button => {
        if (!button) return;
        button.disabled = busy || this.variantDisabled;
        button.classList.toggle('disabled', busy);
        button.setAttribute('aria-busy', String(busy));
      });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }


    toggleAddButton(disable, text) {
      this.variantDisabled = disable;
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.disabled = !!this.isSubmitting;
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();
